"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableTurnLeftIcon = PrintableTurnLeftIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableTurnLeftIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M0 12.002c0 6.616 5.383 11.998 12 11.998s12-5.382 12-11.998-5.384-12.002-12-12.002-12 5.385-12 12.002zM1.080 12.002c0-6.023 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 4.355-2.57 8.112-6.268 9.864v-8.907c0-1.257-0.752-3.635-3.596-3.635h-7.909l3.958-3.957c0.219-0.219 0.219-0.577 0-0.796-0.221-0.22-0.578-0.22-0.798 0l-4.917 4.917c-0.107 0.106-0.165 0.249-0.165 0.399s0.059 0.293 0.165 0.399l4.917 4.916c0.108 0.11 0.253 0.163 0.397 0.163s0.288-0.056 0.399-0.165c0.219-0.219 0.219-0.576-0.002-0.795l-3.956-3.956h7.909c2.444 0 2.471 2.406 2.471 2.509v9.233c0 0.043 0.016 0.084 0.025 0.124-1.115 0.386-2.307 0.605-3.552 0.605-6.022 0-10.92-4.898-10.92-10.918z",
    fill: color
  }));
}